import _ from 'lodash';
import { createContext, useContext, useMemo, } from 'react';
import { gEnums } from '../../enums/globalEnums';
import { ParentContext } from './ParentContext';
import { GolfLayout, SportsProviders } from '../../../projectSpecific/sports/cnr/contexts/contextHelpers/SportsProviders';
import { useRenders } from './useHelpers/useRenders';

export const PageComponentContext = createContext({});

const PageComponentProvider = ({ children }) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};

  const { currentSettings_state, paps_state } = states ?? {};
  const { gvviSettings } = currentSettings_state ?? {};
  const { aps_viewItems } = gvviSettings ?? {};
  const { pathViews } = paps_state ?? {};

  useRenders('PageComponentProvider', true, true);

  const { organizations: organizationsKey, districts: districtsKey, sports: sportsKey } = pathViews ?? {};

  const component_content = useMemo(() => {
    const pv = _.findLast(_.keys(pathViews), (pv) => {
      return _.get(aps_viewItems, [pv, 'pageSettings', 'useComponentContent']) &&
        _.get(aps_viewItems, [pv, 'pageSettings', 'componentContent'])
    })
    return pv ? _.get(aps_viewItems, [pv, 'pageSettings', 'componentContent']) : null
  }, [pathViews, aps_viewItems])

  return <GolfLayout
    enabled={component_content === gEnums.componentContentTypes.golfTournament}
  >
    <SportsProviders
      component_content={component_content}
      organizationsKey={organizationsKey}
      districtsKey={districtsKey}
      sportsKey={sportsKey}
    >
      {children}
    </SportsProviders>
  </GolfLayout>
};

export default PageComponentProvider;
